<template>
    <div class="generic-page mt-page" :class="$mq == 'sm' ? 'mx-1' : 'mx-5'">

        <div v-if="contentKey"
             v-html="$i18n.gt(contentKey)">
            {{  contentKey }}
        </div>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'

/**
 * Component to display a page with all (body) content loaded from a single translation entry.
 */
export default Vue.extend({
    name: 'GenericPage',
    props: {
        contentKey: String,
    },
    computed: {
        language() {
            return this.$store.state.language
        }
    },
})

</script>

<style lang="scss">
    .generic-page {
        h3 {
            margin-top: 0.5em;
        }
    }
</style>
